import { Fragment, ReactNode, RefObject, useEffect } from 'react'

// we stole this code from headless ui
// https://github.com/tailwindlabs/headlessui/blob/226042231d7529d530be7c65790fbb681b5adb63/packages/%40headlessui-react/src/utils/focus-management.ts#L29-L101

const autoFocusableSelector = [
    // In a perfect world this was just `autofocus`, but React doesn't pass `autofocus` to the DOM...
    '[data-autofocus]',
]
    .map(
        process.env.NODE_ENV === 'test'
            ? // TODO: Remove this once JSDOM fixes the issue where an element that is
              // "hidden" can be the document.activeElement, because this is not possible
              // in real browsers.
              (selector) => `${selector}:not([tabindex='-1']):not([style*='display: none'])`
            : (selector) => `${selector}:not([tabindex='-1'])`
    )
    .join(',')

const getAutoFocusableElements = (container: HTMLElement | null = document.body) => {
    if (container == null) return []
    return Array.from(container.querySelectorAll<HTMLElement>(autoFocusableSelector)).sort(
        // We want to move `tabIndex={0}` to the end of the list, this is what the browser does as well.
        (a, z) => Math.sign((a.tabIndex || Number.MAX_SAFE_INTEGER) - (z.tabIndex || Number.MAX_SAFE_INTEGER))
    )
}

type AutoFocusHandlerProps = {
    containerRef: RefObject<HTMLElement>
    children?: ReactNode
}

export const AutoFocusHandler = ({ containerRef, children }: AutoFocusHandlerProps) => {
    useEffect(() => {
        if (containerRef.current) {
            const elements = getAutoFocusableElements(containerRef.current)
            if (elements.length) {
                elements[0].focus({ preventScroll: true })
            }
        }
    }, [containerRef])

    return <Fragment>{children}</Fragment>
}
